<template>
    <li
        class="pl-4 font-semibold text-gray-700 hover:bg-indigo-600  transition duration-100 ease-in-out"
        :class="`${activeClass}`"
    >
        <button
            @click="$router.push(`${path}`)"
            class="py-4 focus:outline-none w-full transition duration-100 ease-in-out"
        >
            <span class="flex items-center">
                <slot />
                <span
                    class="ml-4 capitalize font-medium text-sm"
                    >{{ name }}</span
                >
            </span>
        </button>
    </li>
</template>

<script lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

export default {
    props: ["name", "path"],
    setup(props) {
        const route = useRoute();
        const activeClass = computed(() =>
            route.path === props.path
                ? ` border-indigo-800 bg-[#fbd415] rounded text-[#1e40af] hover:text-[#fff]`
                : `text-white`
        );
    

        return {
            activeClass,
        };
    },
};
</script>
